export const importantCSS = (styles) => {
  return Object.keys(styles).reduce((acc, key) => {
    return { ...acc, [key]: `${styles[key]} !important` };
  }, {});
};
